import { useEffect, useRef } from "react";

export const Orb = () => {
  const canvasRef = useRef(null);
  const mouse = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let w, h, r;
    let rotY = 0;
    let tiltX = 0.35;
    let targetTilt = 0.35;
    let targetSpin = 0;

    const N = 420;
    const pts = [];
    for (let i = 0; i < N; i++) {
      const phi = Math.acos(1 - (2 * (i + 0.5)) / N);
      const theta = Math.PI * (1 + Math.sqrt(5)) * i;
      pts.push({ phi, theta });
    }

    const resize = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      w = canvas.width = rect.width * window.devicePixelRatio;
      h = canvas.height = rect.height * window.devicePixelRatio;
      r = Math.min(w, h) * 0.36;
    };
    resize();
    window.addEventListener("resize", resize);

    const onMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.current.x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      mouse.current.y = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    };
    window.addEventListener("pointermove", onMove);

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      targetTilt = 0.35 + mouse.current.y * 0.25;
      targetSpin = mouse.current.x * 0.5;
      tiltX += (targetTilt - tiltX) * 0.05;
      rotY += 0.0022 + targetSpin * 0.004;

      const cx = w / 2;
      const cy = h / 2;

      const grad = ctx.createRadialGradient(cx, cy, r * 0.1, cx, cy, r * 1.4);
      grad.addColorStop(0, "rgba(255,81,47,0.10)");
      grad.addColorStop(0.6, "rgba(221,36,118,0.05)");
      grad.addColorStop(1, "rgba(221,36,118,0)");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, w, h);

      for (let i = 0; i < N; i++) {
        const { phi, theta } = pts[i];
        let x = Math.sin(phi) * Math.cos(theta + rotY);
        let y = Math.cos(phi);
        let z = Math.sin(phi) * Math.sin(theta + rotY);

        const y2 = y * Math.cos(tiltX) - z * Math.sin(tiltX);
        const z2 = y * Math.sin(tiltX) + z * Math.cos(tiltX);

        const scale = 1 / (1.6 - z2 * 0.6);
        const px = cx + x * r * scale;
        const py = cy + y2 * r * scale;
        const depth = (z2 + 1) / 2;

        const size = (0.8 + depth * 2.2) * window.devicePixelRatio;
        const alpha = 0.15 + depth * 0.75;

        const t = i / N;
        const cr = Math.round(255 + (221 - 255) * t);
        const cg = Math.round(81 + (36 - 81) * t);
        const cb = Math.round(47 + (118 - 47) * t);

        ctx.beginPath();
        ctx.arc(px, py, size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${cr},${cg},${cb},${alpha})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("pointermove", onMove);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      data-testid="hero-orb-canvas"
      className="absolute inset-0 w-full h-full"
    />
  );
};
